<div 
    class="flex flex-row border rounded p-3 gap-2 "
    [class.border-blue-500]="colourScheme===alertColourScheme.blue"
    [class.bg-blue-50]="colourScheme===alertColourScheme.blue">
    
    <span 
        class="material-symbols-rounded icon-20"
        [class.text-blue-500]="colourScheme===alertColourScheme.blue"
    >{{alertIcon}}</span>

    <div class="flex flex-col gap-4">
        @if (alertHeaderText) {
            <div class="body-small-bold" id="alert-header">{{alertHeaderText}}</div>
        }
        
        <div class="body-small-regular text-secondary" id="alert-content">{{alertContentText}}</div>
    </div>
    
    @if (showCloseButton) {
        <div class="flex justify-end">
            <span class="material-symbols-rounded icon-20">{{materialSymbols.close}}</span>
        </div>
    }

</div>
